import './commonComponents';
import './vuetify';
import './veeValidate';
import './numeral';
import XssDirective from './xssDirective';

import '@/assets/scss/app.scss';
import '@/assets/css/global.css';
import Vue from 'vue';

// Register XSS directive
Vue.use(XssDirective);
